import { render } from "./App.vue?vue&type=template&id=22a0f5b1"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=22a0f5b1&lang=scss"

import exportComponent from "/Users/williamsandstrom/repos/web/ytopi/ytopi-configurator/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__